import { gql } from '@apollo/client';

export const GET_DISCOUNTS = gql`
    query GetDiscounts {
      discounts {
        id
        name
        description
        rate
      }
    }
`;

export const GET_DISCOUNT = gql`
    query GetDiscount($id: String!) {
      discount(id: $id) {
        id
        name
        description
        rate
      }
    }
`;
